export const infiniteLoading = new Event('infiniteLoading');
